import { render, staticRenderFns } from "./ConsultorioFilaProcedimento.vue?vue&type=template&id=7bb427fd&"
import script from "./ConsultorioFilaProcedimento.vue?vue&type=script&lang=js&"
export * from "./ConsultorioFilaProcedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports